/**
 * Component: Overlay
 */

var ed = ed || {};

ed.overlay = new function() {
    /**
     * Backdrop function, adds the shadowy layer to the background
     */
    this.backdrop = function() {
        if ($('#overlay-backdrop').length !== 1) {
            $('body').append('<div id="overlay-backdrop" class="overlay-backdrop"></div>');
            $('#overlay-backdrop').height($('body').height());

            // Lock scroll
            $.scrollLock(true);

            $('#overlay-backdrop').on('click', function(){
                ed.overlay.destroy();
            });

            // escape click bind on close button
            $(document).keyup(function (e) {
                if (e.keyCode == 27) {
                    ed.overlay.destroy();
                }
            });
        }
    };

    /**
     * Creates the overlay on top of the backdrop
     */
    this.create = function(data) {
        // reset overlay the hard way
        if ($('#overlay').length === 1) {
            $('#overlay, #overlay-content').remove();
        }
        else {
            ed.overlay.backdrop();
        }

        var btnClose = $('<a>x</a>').attr('href', '#closeOverlay').addClass('overlay-close');
        var overlayInner = $('<div>').addClass('overlay-inner').append($('<div>').addClass('overlay-inner-scroll').append(data.content));

        $('body').append($('<div>').attr('id', 'overlay-content').append(btnClose).append(overlayInner).fadeIn("fast"));

        setTimeout(function(){
            $('#overlay-content').addClass('active');
        }, 100);

        if (data['class'] !== undefined) {
            $('#overlay-content').addClass(data['class']);
        }

        $('.overlay-close').on("click", function (e) {
            e.preventDefault();
            ed.overlay.destroy();
        });
    };

    /**
     * Destroy the overlay and the backdrop, also closes all .js-open components
     */
    this.destroy = function() {
        if ($('#overlay-backdrop').length === 1) {
            // Remove all js-active elements
            $('.open').removeClass('open');

            $('#overlay-backdrop, #overlay-content').remove();

            // Unlock scroll
            $.scrollLock(false);
        }
    };
};
